"use strict";
import { getRequest, postRequest } from "@/services/RequestService";

export const getFeedback = async request => {
  const base_route = `claim/feedbacks/responses`;
  const response = await postRequest(base_route, request);
  return response;
};

export const getFeedbackStatistic = async request => {
  const base_route = `claim/feedbacks/statistics`;
  const response = await postRequest(base_route, request);
  return response;
};
